// API Configuration
const config = {
  // For local development, use the backend API server port
  // For production, use relative URLs (empty string)
  // Use window.location to detect if we're in browser vs build
  apiBaseUrl: (typeof window !== 'undefined' && window.location.hostname === 'localhost') 
    ? 'http://localhost:3001' 
    : (process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : '')
};

console.log('🔧 API Config:', {
  apiBaseUrl: config.apiBaseUrl,
  isWindow: typeof window !== 'undefined',
  hostname: typeof window !== 'undefined' ? window.location.hostname : 'N/A',
  nodeEnv: process.env.NODE_ENV
});

export default config;
